export enum FilePreviewState {
  DEFAULT = 'default',
  UPLOADING = 'uploading',
  PREVIEW = 'preview',
  NO_PREVIEW = 'no-preview',
  ERROR = 'error'
}

export enum FilePreviewVariant {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical'
}

export enum FilePreviewErrorMessages {
  INVALID_FORMAT = "Invalid File Format. Please try again.",
  SIZE_LIMIT = "File exceeds size limit.",
  FAILED_TO_LOAD = "Failed to load file from URL",
  UNKNOWN_FILE_NAME = 'unknown-file',
  UPLOAD_CANCEL = "File upload cancelled.",
  NO_FILE_SELECTED = "No file selected.",
  UNABLE_TO_GENEARTE_URL = "Unable to generate the url.",
  NETWORK_ERROR = "Network error! Please try again later.",
  CUSTOM_ERROR = "Error Occured!"
}

export enum FilePreviewEvent {
  NILE_INIT = "nile-init",
  NILE_RECEIVE = "nile-receive",
  NILE_REMOVE = "nile-remove",
  NILE_CANCEL_UPLOAD = "nile-cancel-upload",
  NILE_DESTROY = "nile-destroy"
}